import type { ParticipantsForCombination } from "./getRoomsCells";
import type { ParticipantListTemplateCombination } from "./participantListApi";
import { range, sortBy } from "lodash";

export function copyFromCombination(
  source: ParticipantsForCombination,
  targetTemplate: ParticipantListTemplateCombination,
): ParticipantsForCombination {
  let sourceOffset = 0;
  const sourcePeople = sortBy(Object.entries(source), ([numberOfPeople]) => numberOfPeople)
    .flatMap(([, r]) => r.rooms)
    .flatMap((r) => r.people);
  return sortBy(targetTemplate.rooms, (r) => r.numberOfPeople).reduce((acc, r) => {
    const key = `${r.numberOfPeople}`;
    const newRooms = range(0, r.count).map(() => {
      const previousPeople = sourcePeople.slice(sourceOffset, sourceOffset + r.numberOfPeople);
      sourceOffset += r.numberOfPeople;
      return {
        people: range(0, r.numberOfPeople).map((pIdx) => {
          const previousPerson = previousPeople[pIdx];
          return previousPerson ? { ...previousPerson } : null;
        }),
      };
    });
    const roomsForNumberOfPeople = acc[key]?.rooms ?? [];
    return {
      ...acc,
      [key]: {
        rooms: [...roomsForNumberOfPeople, ...newRooms],
      },
    };
  }, {} as ParticipantsForCombination);
}
